<template>
  <div class="columns mgt-20px is-multiline">
    <produit-default-logistique-impression
      :societe="societe"/>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.tab.logistiqueImpression')}}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('societes.logistiqueImpression.tauxMaintenance')">
              <input-currency v-model="societe.tauxMaintenance" isNumber="true">
              </input-currency>
            </b-field>
          </div>
          <div class="column is-12">
            <table class="VueTables__table table is-bordered is-fullwidth">
              <thead>
                <th class="colonne-responsive">
                  {{ $t('societes.logistiqueImpression.typeProduit') }}
                </th>
                <th class="colonne-responsive">
                  {{ $t('societes.logistiqueImpression.affichageTo') }}
                </th>
              </thead>
              <tbody>
                <tr
                  v-if="moduleProduitFaceUnitaireActive">
                  <td class="is-align-content-center has-text-centered">
                    <div class="column">
                      {{ $t('societes.logistiqueImpression.produit.lc') }}
                    </div>
                  </td>
                  <td>
                    <retro-planning
                      :retroplanning="societe.retroPlanningLc"/>
                  </td>
                </tr>
                <tr
                  v-if="moduleProduitReseauTempoActive">
                  <td class="is-align-content-center has-text-centered">
                    <div class="column">
                      {{ $t('societes.logistiqueImpression.produit.reseauTempo') }}
                    </div>
                  </td>
                  <td>
                    <retro-planning
                      :retroplanning="societe.retroPlanningReseauTempo"/>
                  </td>
                </tr>
                <tr
                  v-if="moduleProduitReseauLcActive">
                  <td class="is-align-content-center has-text-centered">
                    <div class="column">
                      {{ $t('societes.logistiqueImpression.produit.reseauLc') }}
                    </div>
                  </td>
                  <td>
                    <retro-planning
                      :retroplanning="societe.retroPlanningReseauLc"/>
                  </td>
                </tr>
                <tr
                  v-if="moduleProduitReseauMairieActive">
                  <td class="is-align-content-center has-text-centered">
                    <div class="column">
                      {{ $t('societes.logistiqueImpression.produit.reseauMairie') }}
                    </div>
                  </td>
                  <td>
                    <retro-planning
                      :retroplanning="societe.retroPlanningReseauMairie"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import inputCurrency from '@/components/general/inputCurrency';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import produitDefaultLogistiqueImpression from '@/components/parametrage/societes/ajoutEditionSociete/logistiqueImpression/produitDefaultLogistiqueImpression';
import retroPlanning from '@/components/parametrage/societes/ajoutEditionSociete/logistiqueImpression/retroPlanning';

const Parametres = createNamespacedHelpers('parametres');
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
    retroPlanning,
    produitDefaultLogistiqueImpression,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleProduitReseauTempoActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key);
    },
    moduleProduitFaceUnitaireActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key);
    },
    moduleProduitReseauLcActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauLc.key);
    },
    moduleProduitReseauMairieActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.produitReseauMairie.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key,
        PARAMETRES_INTERNE_KEYS.moduleProduitReseauLc.key,
        PARAMETRES_INTERNE_KEYS.produitReseauMairie.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },

};
</script>
